import React, { Component } from "react";
import iconDate from "../component/signup/assets/datePickerIcon.svg";
import { format } from "date-fns";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import DatePicker from "./DatePicker/datepicker";
import styles from "../component/onboarding/onboard.module.css";
import { Col, Row } from "react-bootstrap";

class TransactionDatePicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      displayCalendar: false,
      inputTxt: this.dateFormatter(this.props.value),
      readOnly: true,
      calendarMaxDate: new Date(),
      calendarMinDate: new Date("2019-01-01"),
    };

    this.calendarRef = React.createRef();
    this.showCalendar = this.showCalendar.bind(this);
    this.hideCalendar = this.hideCalendar.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.dateFormatter = this.dateFormatter.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    // this.handleDocumentClickOutside = this.handleDocumentClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("click", this.handleDocumentClick);
    document.addEventListener("mousedown", this.handleDocumentClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleDocumentClick);
    document.removeEventListener("mousedown", this.handleDocumentClickOutside);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({ inputTxt: this.dateFormatter(nextProps.value) });
  }

  dateFormatter(mydate) {
    if (!(mydate instanceof Date)) {
      return "";
    }

    var curr_date = mydate.getDate();
    var curr_month = mydate.getMonth() + 1;
    var curr_year = mydate.getFullYear();
    if (curr_date < 10) {
      curr_date = "0" + curr_date;
    }
    if (curr_month < 10) {
      curr_month = "0" + curr_month;
    }
    mydate = `${curr_date}-${curr_month}-${curr_year}`;
    return mydate;
  }

  showCalendar(e) {
    e.stopPropagation();
    if (this.props.id === "Start_Date") {
      this.props.setLeftCalender(true);
      this.props.setRightCalender(false);
    } else {
      this.props.setLeftCalender(false);
      this.props.setRightCalender(true);
    }
    this.setState((prevState) => ({
      displayCalendar: !prevState.displayCalendar,
    }));
  }

  hideCalendar() {
    if (this.props.id === "Start_Date") {
      this.props.setLeftCalender(false);
    } else {
      this.props.setRightCalender(false);
    }
    this.setState({
      displayCalendar: false,
    });
  }

  handleSelect(date) {
    this.props.changeDate(date, this.props.id);
    date = this.dateFormatter(date);
    this.setState({
      inputTxt: date,
    });
    this.hideCalendar();
  }

  handleDocumentClick(e) {
    if (
      this.calendarRef.current &&
      !this.calendarRef.current.contains(e.target)
    ) {
      this.hideCalendar();
    }
  }

  // handleDocumentClickOutside(e) {
  //   if (this.iconRef.current && !this.iconRef.current.contains(e.target)) {
  //     this.hideCalendar();
  //   }
  // }

  formatDateDisplay(date) {
    if (typeof date === "string") {
      return date;
    }
    return format(date, "dd-MM-yyyy");
  }

  render() {
    return (
      <Row
        className="row"
        style={{
          position: "relative",
          paddingTop: "16px",
        }}
      >
        <Col
          lg={1}
          md={1}
          sm={1}
          xs={1}
          style={{
            fontStyle: "geomanistBook",
            fontWeight: "normal",
            fontSize: "12px",
            letterSpacing: "0.6px",
            color: "#9096A8",
            display: "inline-block",
            paddingRight: "8px",
            textAlign: "center",
            border: "1px solid #D3D4DA",
            borderRadius: "0px",
            borderRight: "0px",
            padding: "9.75px 0px 8.75px 0px",
            borderTopLeftRadius: "6px",
            borderBottomLeftRadius: "6px",
            width: "45px",
          }}
        >
          {this.props.type}
        </Col>
        <Col
          lg={10}
          md={10}
          sm={10}
          xs={10}
          style={{
            paddingLeft: "0px",
            paddingRight: "0px",
            borderBottom: "1px solid #D3D4DA",
            maxWidth: "100px",
          }}
        >
          <input
            className="form-control"
            id="ex1"
            type="text"
            style={{
              background: "#FFFFF",
              fontStyle: "normal",
              fontWeight: "normal",
              fontSize: "12px",
              lineHeight: "0px",
              letterSpacing: "0.6px",
              color: "#3C404A",
              border: "1px solid #D3D4DA",
              borderRadius: "0px",
              borderTopLeftRadius: "0px",
              borderBottomLeftRadius: "0px",
              borderBottom: "none",
              borderRight: "0px",
              borderLeft: "0px",
              padding: "12px 6px 14px 1px",
            }}
            onClick={this.showCalendar}
            value={this.state.inputTxt}
          />
        </Col>
        <Col
          lg={1}
          md={1}
          sm={1}
          xs={1}
          onClick={this.showCalendar}
          style={{
            paddingTop: "3px",
            background: "#FFFFF",
            cursor: "pointer",
            border: "1px solid #D3D4DA",
            borderLeft: "0px",
            borderTopRightRadius: "6px",
            borderBottomRightRadius: "6px",
            position: "relative",
          }}
        >
          <span
          // ref={this.iconRef}
          >
            <img
              src={iconDate}
              alt=""
              style={{
                width: "15px",
                height: "15px",
                position: "absolute",
                top: "12px",
                right: "10px",
              }}
            />
          </span>
        </Col>
        <div
          ref={this.calendarRef}
          id={this.props.id + "_cal"}
          style={{
            display: this.state.displayCalendar
              ? (this.props.id === "Start_Date" && this.props.leftCalender) ||
                (this.props.id === "End_Date" && this.props.rightCalender)
                ? "block"
                : "none"
              : "none",
            position: "absolute",
            zIndex: "1000",
            top: "8px",
            right: "-6px",
          }}
        >
          <div
            className={
              this.props.align === "right" ? styles.calender2 : styles.calender
            }
          >
            <DatePicker
              onChange={this.handleSelect}
              maxDate={
                this.props.type === "To"
                  ? this.state.calendarMaxDate
                  : this.props.maxDate
              }
              minDate={
                this.props.type === "From"
                  ? this.state.calendarMinDate
                  : this.props.minDate
              }
              date={new Date()}
              color="#0061D3"
            />
          </div>
        </div>
      </Row>
    );
  }
}

export default TransactionDatePicker;
